import React from 'react';
import logo from '../logo.png';
import '../App.css';
import Dropzone from 'react-dropzone'
import styled from "styled-components";
import { LoopCircleLoading } from 'react-loadingg';

import _ from 'underscore'
import imageCompression from 'browser-image-compression';

import Form from '../components/form'
import TandCModal from '../components/tandc'

import { camelize } from '../utils/utils'

import {getWindowDimensions} from '../utils/getWindowDimensions'

// axios.defaults.withCredentials = true

const style = {
  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  formContainer: {
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 30,
  },
  image_attachment: {
    width: '500px',
    height: '500px',
    padding: 10,
    outline: '.5px dotted',
    outlineOffset: -10,
    overflow: 'hidden'
  },
  img_att: {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  show_percent: {
    color: 'red'
  },
  show_percent_green: {
    color: 'green'
  },
  btn_container: {
    width: '300px',
    textAlign: 'center',
    padding: 10
  },
  brn: {
    lineHeight: '500px'
  },
  result_value: {
    display: 'flex',
    fontSize: 14,
    justifyContent: 'space-between'
  },
  main_result: {
    // background: 'grey'
    background: '#292c34',
    lineHeight: 2,
    color: 'white',
    borderRadius: 5,
    padding: 10
  }
}

const Button = styled.button`
  background-color: black;
  color: white;
  font-size: 20px;
  padding: 10px 60px;
  border-radius: 5px;
  margin: 10px 0px;
  cursor: pointer;
`;
// Usage
export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      response: '',
      loading: false,
      submitted: false,
      submitData: '',
      modelOpen: false,
    }

    this.handleDropImage = this.handleDropImage.bind(this)
    this.sendImage = this.sendImage.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.restart = this.restart.bind(this)
    this.tandcAgree = this.tandcAgree.bind(this)
  }

  componentDidMount() {
    if(!localStorage.getItem('covid-xray-tandc')) {
      this.setState({modelOpen: true})
    }
  }

  tandcAgree() {
    console.log('hereer')
    localStorage.setItem('covid-xray-tandc', true);
    this.setState({modelOpen: false})
  }

  async handleDropImage(upFile) {
    this.setState({loading: true})
    let options = {
      maxSizeMB: 0.3,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    console.log(upFile[0])
    let compressedFile = upFile[0]
    if(compressedFile.size > 500000) {
      compressedFile = await imageCompression(upFile[0], options);
    }
    console.log(compressedFile)
    this.setState({file: compressedFile, loading: false})
  }

  restart() {
    console.log('download')
    // var prtContent = document.getElementById("print-area");
    // var WinPrint = window.open();
    // WinPrint.document.write(prtContent.innerHTML);
    // WinPrint.document.write('')
    // WinPrint.document.close();
    // WinPrint.focus();
    // WinPrint.print();
    // WinPrint.close();

    this.setState({file: '',
    response: '',
    submitted: false,
    submitData: ''})

  }

  async handleSubmit(data) {
    console.log('data', data)
    this.setState({loading: true, submitData: data});
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json", "Access-Control-Allow-Origin", "*");

    var raw = JSON.stringify({resultId: this.state.response.img_id, ...data})

    var requestOptions = {
      method: 'POST',
      mode: 'cors',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://covid-backend.bwar.me/api/submit", requestOptions)
      .then(response => response.text())
      .then(result => {
        console.log(result)
        this.setState({loading: false, submitted: true})
      })
      .catch(error => {
        console.log('error', error)
        alert(`${error} Please try again`)
        this.setState({loading: false, response: ''})
      }
      );
  }

  async sendImage() {

    if(!this.state.file) {
      alert('Please input file!');
      return;
    }

    this.setState({loading: true})
    var c = document.createElement('canvas');
    var img = document.getElementById('Img1');
    c.height = img.naturalHeight;
    c.width = img.naturalWidth;
    var ctx = c.getContext('2d');

    ctx.drawImage(img, 0, 0, c.width, c.height);
    var base64String = c.toDataURL();
    // console.log(base64String.split(',')[1])

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({"image": base64String.split(',')[1]})

    var requestOptions = {
      method: 'POST',
      mode: 'cors',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://covid-backend.bwar.me/api/predict", requestOptions)
      .then(response => response.text())
      .then(result => {
        console.log(result)
        let retResult = JSON.parse(result)
        let newResult = _.omit(retResult, 'img_url', 'img_id')
        let firstKey = Object.keys(newResult)[0]

        if(firstKey === 'NonXray') {
          alert("Please input X-Ray image!");
          this.setState({file: '', loading: false})
        } else {
          this.setState({response: typeof result === 'string' ? JSON.parse(result) : result, loading: false})
        }
      })
      .catch(error => {
        console.log('error', error)
        alert(`${error} Please try again`)
        this.setState({loading: false, response: ''})
      }
      );

  }
  
  render() {
    const { file, response, loading, submitted, submitData, modelOpen } = this.state;
    let result = response.result
    console.log(getWindowDimensions())

    if(loading) {
        return(
            <div style={{minHeight: 500}}><LoopCircleLoading /></div>
        )
    }


    // console.log(response)
    return (
      <>
        <TandCModal isOpen={modelOpen} agreed={this.tandcAgree} />
        <div style={style.container}>
        {
          file
          ?
          <div style={style.image_attachment}>
            <img id="Img1" src={URL.createObjectURL(file)} alt="input" style={style.img_att}/>
          </div>
          :
          <Dropzone
          onDrop={acceptedFiles => this.handleDropImage(acceptedFiles)}
          accept="image/jpeg, image/png, image/jpg">
            {({getRootProps, getInputProps}) => (
              <section style={style.image_attachment}>
                  <div {...getRootProps()} >
                  <input {...getInputProps()}/>
                  <div style={{height: '500px'}}>Drag and drop X-Ray image here, or click here to select files</div>
                  </div>
              </section>
            )}
          </Dropzone>
        }
        <div style={style.btn_container}>
          {
            !result ?
            <div style={style.brn}>
              <Button onClick={this.sendImage}>
                Check
              </Button>
            </div>
            :
            <>
            <div style={style.brn}>
              <Button onClick={this.restart}>
                Restart
              </Button>
            </div>
            <div style={style.main_result}>
              {_.map(result, (val, key) => key !== 'NonXray' && (
                <div style={style.result_value} key={key}><span>{key === 'COVID19' ? `${key} (Suspect)` : key} - </span><span style={ Object.keys(result)[0] === key ? style.show_percent_green : style.show_percent}>{Math.round((val + Number.EPSILON) * 100) / 100} %</span></div>))}
            </div>
            </>
          }
        </div>
            <div style={style.image_attachment}>
              {
                response && response.img_url &&
                <img src={response.img_url} alt="heatmap" style={style.img_att}/>
              }
            </div>
        </div>
        <div style={style.formContainer}>
          {
          result && 
          // (!submitted ? 
          <Form submit={this.handleSubmit} results={response} allDisabled={submitted} download={this.download} submitData={submitData} downloadData={{
            input: file,
            result: result,
            output: response.img_url
          }}/>
          // :
          // <Values data={submitData}/>)
          }
        </div>
        </>
    )
  }
}